import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { CookieConsent } from "react-cookie-consent";
import {Link} from "react-router-dom";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />

    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="userConsentCookie"
      style={{ background: "#2B373B", padding: "10px" }}
      buttonStyle={{
        background: "#4e503b",
        color: "#fff",
        fontSize: "14px",
        padding: "8px 16px",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
      }}
      expires={150}
    >
      <div>
        This website uses cookies to enhance your experience.
        {' '}
        <div>
          <span>You can read our privacy policy here</span>
          {' '}
          <a style={{color: 'white', textDecoration: 'underline'}} target="_blank" href='/privacy-policy'>Privacy policy</a>
        </div>
      </div>
    </CookieConsent>
  </StrictMode>,
);
